<script>
    import PromocodeListItem from "@xd/components/PromocodeListItem";
    import BaseButton from "@main/packages/BaseButton";

    export default {
        name: "PromocodeList",
        components: { PromocodeListItem, BaseButton },
        data() {
            return {
                activeKey: 99,
            };
        },
        computed: {
            promocodeList() {
                return [
                    {
                        title: "Скидка 10% на Рюкзак Bobby Hero",
                        code: "SPBHR10",
                        image: "hero",
                        slug: "xd-design-bobby-hero-regular",
                        color: [
                            "#000000",
                            "#CBCBCB",
                            "#FF5D59",
                            "#7AA6FF",
                            "#5ECBB4",
                            "#A6DBEC",
                        ],
                    },
                    {
                        title: "Скидка 10% на Bobby Hero Spring",
                        code: "SPHRSP10",
                        image: "spring",
                        slug: "xd-design-bobby-hero-spring",
                        color: ["#C9CFD9", "#FFA9C3", "#F0CE91"],
                    },
                    {
                        title: "Скидка 10% на Рюкзак Flex Gym Bag",
                        code: "SPFLXGB10",
                        image: "gym",
                        slug: "xd-design-flex-gym-bag",
                        color: ["#000000"],
                        text: "в черном цвете",
                    },
                    {
                        title: "Скидка 10% на Рюкзак Soft Daypack",
                        code: "SPSFDP10",
                        image: "soft-daypack",
                        slug: "xd-design-soft-daypack",
                        color: ["#000000", "#b3b3b1", "#7AA6FF", "#5ecbb4"],
                        isNew: true,
                    },
                    {
                        title: "Скидка 10% на Рюкзак Bobby Soft",
                        code: "SPBSOFT10",
                        image: "soft",
                        slug: "xd-design-bobby-soft",
                        color: ["#000000", "#CBCBCB", "#7AA6FF", "#917476", "#5ECBB4"],
                    },
                    {
                        title: "Скидка 10% на Рюкзак Bobby Soft Art",
                        code: "SPBSFTA10",
                        image: "soft-art",
                        slug: "xd-design-bobby-soft-art",
                        color: ["#28ACCE", "#FFA9C3", "#000000"],
                    },
                    {
                        title: "Скидка 10% на Рюкзак Bobby Sling",
                        code: "SPSLNG10",
                        image: "sling",
                        slug: "xd-design-bobby-sling",
                        color: ["#000000", "#CBCBCB", "#7AA6FF"],
                    },
                    {
                        title: "Скидка 10% на Рюкзак Bobby Bizz 2.0",
                        code: "SPBBZZ10",
                        image: "bizz",
                        slug: "xd-design-bobby-bizz-2-0",
                        color: ["#000000", "#b0b6c1", "#7aa6ff"],
                    },
                    {
                        title: "Скидка 10% на Рюкзак Bizz Backpack",
                        code: "SPBZBP10",
                        image: "bizz-backpack",
                        slug: "xd-design-bizz-backpack",
                        color: ["#000000", "#B0B6C1", "#7AA6FF"],
                        isNew: true,
                    },
                    {
                        title: "Скидка 10% на Рюкзак Bobby Urban",
                        code: "SPURBN10",
                        image: "urban",
                        slug: "xd-design-bobby-urban",
                        color: ["#CBCBCB"],
                        text: "в сером цвете",
                    },
                    {
                        title: "Скидка 10% на Рюкзак Bobby Explore",
                        code: "SPBEXP10",
                        image: "bobby-explore",
                        slug: "xd-design-bobby-explore",
                        color: ["#000000", "#7AA6FF", "#93D1A8"],
                        isNew: true,
                    },
                    {
                        title: "Скидка 10% на Рюкзак Bobby Trolley",
                        code: "SPTRLL10",
                        image: "trolley",
                        slug: "xd-design-bobby-trolley",
                        color: ["#000000"],
                        text: "в черном цвете",
                    },
                    {
                        title: "Скидка 10% на Сумку Urban Bumbag",
                        code: "SPURBB10",
                        image: "bumbag",
                        slug: "xd-design-urban-bumbag",
                        color: ["#CBCBCB"],
                        text: "в сером цвете",
                    },
                    {
                        title: "Скидка 10% на Сумку через плечо Boxy Sling",
                        code: "SPBXSLN10",
                        image: "boxy-sling",
                        slug: "xd-design-boxy-sling",
                        color: ["#000000", "#7AA6FF"],
                        isNew: true,
                    },
                ];
            },
        },
        methods: {
            goToLink() {
                this.$router.push({ name: "Home", hash: "#catalog" });
            },
            setActiveKey(key) {
                this.activeKey = key;
            },
        },
    };
</script>

<template>
    <div class="promocode-list">
        <div class="promocode-list__helper desktop-hidden">
            Нажми на промокод, чтобы скопировать!
        </div>
        <div class="promocode-list__wrapper">
            <promocode-list-item
                v-for="(promocodeItem, i) in promocodeList"
                :key="i"
                :promocode="promocodeItem"
                :active-key="activeKey"
                @set-active-key="setActiveKey"
            ></promocode-list-item>

            <base-button
                class="promocode-list__link outline"
                variant="v1"
                size="lg"
                @click="goToLink"
            >
                ПЕРЕЙТИ К ПОКУПКАМ
            </base-button>
        </div>
    </div>
</template>

<style lang="scss">
    .promocode-list__helper {
        margin-bottom: 18px;
        padding: 7px 10px;
        color: var(--info-text);
        font-size: 14px;
        font-weight: 500;
        line-height: 28px;
        text-align: center;
        background: #f5f6f8;
    }

    .promocode-list__wrapper {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;

        @include bp($bp-tablet-md) {
            margin: 0 -10px;
        }
    }

    .promocode-list__link {
        display: block;
        width: 100%;

        @include bp($bp-tablet-md) {
            width: calc(100% / 2 - 20px);
        }

        @include bp($bp-desktop-sm) {
            width: calc(100% / 3 - 20px);
        }

        @include bp($bp-tablet-md) {
            margin: 0 10px;
        }
    }
</style>
